import React from "react";
import orbisLinesIcon from "../assets/icons/orbislines-app-icon.svg";
import orbisLinesMockup from "../assets/mockups/orbislines-mockup.png";
import orbisLinesMockup2 from "../assets/mockups/orbislines-mockup-2.png";
import appleStoreBadge from "../assets/badges/apple-store-badge.svg";
import googlePlayBadge from "../assets/badges/google-play-badge.svg";
import NavBar from "./NavBar";
import { publishedApps } from "../data/appData";

const OrbisLinesPage = ({ language, onLanguageChange, t }) => {
  const orbisLinesApp =
    publishedApps.find((app) => app.detailPath === "/apps/orbislines") || {};
  const appStoreUrl = orbisLinesApp.appStoreUrl || "#";
  const googlePlayUrl = orbisLinesApp.googlePlayUrl || "#";
  const highlights = t("orbis.highlights.items") || [];
  const steps = t("orbis.workflow.steps") || [];
  const scoring = t("orbis.scoring.items") || [];

  return (
    <div className="page foody-page trains-page" id="orbis-top">
      <NavBar
        language={language}
        onLanguageChange={onLanguageChange}
        items={[
          { href: "/#apps", label: t("orbis.meta.back") },
          {
            href: "/apps/orbislines/static/support",
            label: t("orbisSupport.badge"),
            className: "nav-support-outline",
          },
        ]}
      />

      <main className="foody-main">
        <section className="foody-hero">
          <div className="foody-hero-copy">
            <div className="foody-hero-icon">
              <img src={orbisLinesIcon} alt="Orbis Lines game icon" />
            </div>
            <span className="foody-eyebrow">{t("orbis.hero.eyebrow")}</span>

            <h1>{t("orbis.hero.title")}</h1>
            <p>{t("orbis.hero.subtitle")}</p>
            <div className="store-badges foody-store-badges">
              {orbisLinesApp.appStoreUrl && (
                <a
                  className="store-badge"
                  href={appStoreUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={appleStoreBadge} alt="App Store" />
                </a>
              )}
              {orbisLinesApp.googlePlayUrl && (
                <a
                  className="store-badge"
                  href={googlePlayUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={googlePlayBadge} alt="Google Play" />
                </a>
              )}
            </div>
          </div>
          <div className="foody-hero-visual">
            <div className="foody-mockup trains-mockups">
              <img src={orbisLinesMockup} alt="Orbis Lines game screen 1" />
              <img src={orbisLinesMockup2} alt="Orbis Lines game screen 2" />
            </div>
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-section-head">
            <h2>{t("orbis.highlights.title")}</h2>
            <p>{t("orbis.highlights.subtitle")}</p>
          </div>
          <div className="foody-grid">
            {highlights.map((item) => (
              <article className="foody-card" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="foody-section foody-section-alt">
          <div className="foody-section-head">
            <h2>{t("orbis.workflow.title")}</h2>
            <p>{t("orbis.workflow.subtitle")}</p>
          </div>
          <div className="foody-steps">
            {steps.map((step, index) => (
              <div className="foody-step" key={step.title}>
                <span className="foody-step-index">0{index + 1}</span>
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-section-head">
            <h2>{t("orbis.scoring.title")}</h2>
            <p>{t("orbis.scoring.subtitle")}</p>
          </div>
          <div className="foody-tags">
            {scoring.map((item) => (
              <span className="foody-tag" key={item}>
                {item}
              </span>
            ))}
          </div>
          <p className="foody-note">{t("orbis.scoring.note")}</p>
        </section>

        <section className="foody-cta">
          <div>
            <h2>{t("orbis.cta.title")}</h2>
            <p>{t("orbis.cta.desc")}</p>
          </div>
          <div className="store-badges foody-store-badges">
            {orbisLinesApp.appStoreUrl && (
              <a
                className="store-badge"
                href={appStoreUrl}
                target="_blank"
                rel="noreferrer"
              >
                <img src={appleStoreBadge} alt="App Store" />
              </a>
            )}
            {orbisLinesApp.googlePlayUrl && (
              <a
                className="store-badge"
                href={googlePlayUrl}
                target="_blank"
                rel="noreferrer"
              >
                <img src={googlePlayBadge} alt="Google Play" />
              </a>
            )}
          </div>
        </section>
      </main>
    </div>
  );
};

export default OrbisLinesPage;
